import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
// import {applyMiddleware, createStore} from "redux";
// import {composeWithDevTools} from "@redux-devtools/extension";
import {Provider} from "react-redux";
import rootReducer, {rootSaga} from "./modules";
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from "redux-saga";
import {ThemeProvider, CssBaseline} from '@mui/material';
import theme from './theme/index';

// MUI 라이선스 설정
import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY);

const rootNode = document.getElementById('root');
const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({thunk: false}).concat(sagaMiddleware),
    // Redux DevTools는 configureStore에서 기본적으로 활성화됨
    devTools: process.env.NODE_ENV !== 'production',
});
sagaMiddleware.run(rootSaga);

ReactDOM.createRoot(rootNode).render(
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <React.StrictMode>
                    <App/>
                </React.StrictMode>
            </ThemeProvider>
        </BrowserRouter>
    </Provider>,
);

reportWebVitals();

export default store;